import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionContext } from '../authentication';

/**
 * Gestao de acessos nao depende de feature de projeto: e do sistema.
 * Visivel apenas para admin -- o backend recusa as rotas para os demais.
 */
const UsersMenu: FC<MenuItemStateProps> = ({ isMini }) => {
  const { isAdmin } = useSessionContext();
  const { COLORS } = useTheme();
  const navigate = useNavigate();

  if (!isAdmin) return <></>;

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: 'Usuários',
        icon: <ManageAccountsIcon sx={{ color: COLORS.primary.main }} />,
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={() => navigate('/users', { replace: true })}
    />
  );
};

export { UsersMenu };
